import { gql } from "@apollo/client";

const ACCEPT_TRAINEESHIP = gql`
  mutation acceptTraineeship($traineeshipID: String!, $email: String!, $name: String!, $position: String!, $institution: Int!, $status: String!) {
    acceptTraineeship(traineeshipID: $traineeshipID, email: $email, name: $name, position: $position, institution: $institution, status: $status) 
  }
`;

export default ACCEPT_TRAINEESHIP;